export default "__VITE_ASSET__Dqv7Zi8Y__"